module.exports = __webpack_public_path__ + "media/19.123a823b.mp3";